<template >
  <div>
    <div class="sr-comInfo">
      <div class="sr-layout-wrap">

        <el-image src="https://sara-infinity.com/logo.jpg" style="float: left; height: 10%;width: 10%"  />

        <div class="sr-comInfo-r" style="margin-top: 3%;margin-left: 3%">
          <div class="sr-comInfo-title J-title-comName">
            <div class="title-txt">
              <a href="https://www.sara-infinity.com">
                <h1 style="font-size: 22px">
                  GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD.<i class="ob-icon icon-down"></i>
                </h1>
              </a>
            </div>

          </div>
          <div class="sr-comInfo-sign">
            <div class="sign-item">
              <i class="el-icon-message"></i> <span class="txt-year">525205929@qq.com</span>
              <div class="tip arrow-top tip-gold">
                <div class="tip-con">
                  <p class="tip-para">Suppliers with verified business licenses</p>
                </div>
                <span class="arrow arrow-out">
                                    <span class="arrow arrow-in"></span>
                                </span>
              </div>
            </div>
            <div class="sign-item as-logo" data-title="Audited by an independent third-party inspection agency">
              <i class="el-icon-phone"></i>
              <span class="txt-year">+86 18680557608</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-menu
        default-active="5"
        class="el-menu-demo"
        mode="horizontal"
        @select=""
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        style="padding-left: 21.2%">
      <el-menu-item index="1"><router-link to="/home" >Home</router-link></el-menu-item>
      <el-menu-item index="2"><router-link to="/products" >Products</router-link></el-menu-item>
      <el-menu-item index="3" ><router-link to="/aboutUs" >About Us</router-link></el-menu-item>
      <el-menu-item index="4" disabled><router-link to="" >Solutions</router-link></el-menu-item>
      <el-menu-item index="5"><router-link to="/sendUs" >Send Us</router-link></el-menu-item>
    </el-menu>


    <!------------------------------------------------------------------分割线------------------------------------------------------------------------------------------------>



    <div class="sr-layout-wrap" style="height: 130%; margin-top: 2%">


      <div class="sr-layout-block J-msg-block" faw-module="supplier_inquiry" faw-exposure style="height: 130%">
        <div class="sr-txt-title">
          <h2 class="sr-txt-h2">Send your message to this supplier</h2>
        </div>
        <div class="sr-layout-content sr-sendMsg">
          <div class="sr-sendMsg-form obelisk-form">
            <input type="hidden" id="showRoomUrl" >

              <input type="hidden" id="loginStatu" value="0" />
              <div class="sr-sendMsg-row">
                <div class="sr-sendMsg-label">
                  <em>*</em>From:
                </div>
                <div class="sr-sendMsg-field J-quick-inquiry-email-wrap">
                  <input class="input-text sr-sendMsg-input" name="senderMail" type="text" placeholder="Enter your email address" value="" />
                </div>
              </div>
              <div class="sr-sendMsg-row">
                <div class="sr-sendMsg-label">
                  <em>*</em>To:
                </div>
                <div class="sr-sendMsg-field">

                  <span class="sr-sendMsg-name">Ms. zhang</span>
                </div>
              </div>
              <div class="sr-sendMsg-row">
                <div class="sr-sendMsg-label">
                  <em>*</em>Message:
                </div>
                <div class="sr-sendMsg-field">
                  <textarea class="input-textarea sr-sendMsg-area" name="content" id="inquiryContent" cols="90" rows="5" placeholder="We suggest you detail your product requirements and company information here." maxlength="4000"></textarea>
                  <p class="sr-sendMsg-tips">Enter between 20 to 4,000 characters.</p>
                </div>
              </div>
              <div class="">
                <div class="sr-sendMsg-label"></div>
                <div class="sr-sendMsg-field">
                  <div id="captcha" style="float:left;"></div>
                  <input type="hidden" name="hmToken" class="J-hmToken" value="" />
                  <input type="hidden" class="J-hmCaptchaId"  />
                </div>
              </div>
              <div class="sr-sendMsg-row">
                <div class="sr-sendMsg-field">

                  <button fun-inquiry-supplier  class="btn btn-main sr-sendMsg-btn" id="inquirySend" @click="send()">Send</button>
                  <span class="sr-sendMsg-promote">This is not what you are looking for?</span>

                </div>
              </div>

          </div>
        </div>
      </div>






      <div class="sr-layout-block contact-block" faw-module="contact_ds" faw-exposure  style="height: 130%" >
        <div class="sr-txt-title">
          <span class="sr-txt-h2">Contact Details</span>
          <div class="contact-options">

            <span>
					</span>
          </div>
        </div>
        <div class="contact-info">
          <div class="info-item">
            <div class="info-label">Address:</div>
            <div class="info-fields">
              <div class="item-address-wrap">
    	                    <span class="contact-address">
    	                        baiyun, guangzhou, guangdong, China
    				         	    	                    </span>

              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-label"></div>
            <div class="info-fields">
              <div class="info-options">
                <a  rel="nofollow" target="_blank" @click="waitingSend()"><i class="ob-icon icon-fill"></i>Factory</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-label" style="width: 100%">Local Time:<span style="margin-left: 7%">09:00-18:00</span></div>
            <div class="info-fields J-localtime"></div>
          </div>


        </div>

      </div>
    </div>


    <div style="height: 453px"></div>



    <!-----------------------------------------------------------------------------------底部------------------------------------------------------------------------->
    <div class="m-footer pad-footer m-sr-footer">
      <div class="grid">
        <div class="m-footer-simple-links pad-footer-simple">
          <div class="m-footer-simple-links-group pad-footer-hide">
            <div class="m-footer-simple-links-row">
              <a>{{language?"热门产品":"Hot Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国产品":"China Products"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国制造商/供应商":"Chinese Manufacturers/Suppliers"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"中国批发":"China Wholesale"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"批发价格":"Wholesale Price"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"行业网站":"Industry Sites"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"区域渠道":"Regional Channels"}}</a>
              <span class="m-gap-line"></span>
              <a>{{language?"产品指数":"Product Index"}}</a>

            </div>

          </div>
          <div class="m-footer-simple-links-group pad-footer-oneline">
            <div class="m-footer-simple-links-row m-footer-copyright">
              Copyright &copy; 2023-2024 <a class="J-focusChinaLink" href="https://www.sara-infinity.com/"
                                            rel="nofollow"
                                            target="_blank">{{language?"广州至臻机车配件有限公司":"GUANGZHOU ZHIZHEN VEHICLE PARTS CO.,LTD."}}</a>&nbsp;{{language?"保留所有权利":"All Rights Reserved."}}

            </div>
            <span class="m-gap-line"></span>
            <div class="m-footer-simple-links-row">
              <a rel="nofollow" target="_self">{{language?"保留所有权利":"User Agreement"}}</a>
            </div>
          </div>
          <div style="display: flex;justify-content: center;width: 100%">

            <div class="m-footer-simple-links-row m-footer-govIcon pad-hide" style="color: blue" >
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44011102483772" rel="noreferrer" target="_blank"><i class="m-ico m-ico-police-new"></i>粤公网安备44011102483772</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" data-v-644aa589="" style="margin-left: 20px;">粤ICP备2024199978号</a>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
export default {
  data() {
    return {
      localImage: require('@/assets/img/logo.jpg'),
      loading: false,
      passFocus: false,
      isCetc: true,
      formWidth: '',
      bgImage: '',
      form: {
        username: '',
        password: '',
        platform: ''
      },
      list: []
    }
  },
  methods: {

    waitingSend() {
      this.$message.info("waiting");
    },


    send() {
      this.$message.success("Successfully");


    },


    isIE() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$message.info('ie浏览器不兼容！')
        return true;
      }
      return false;
    },

  },

  mounted() {
    let random = Math.floor(Math.random() * 5) + 1;
    this.bgImage = {
      backgroundImage: 'url(' + require('../assets/img/bg.jpg'),
      backgroundRepeat: 'no-repeat',

    };
    if (this.isIE()) {
      this.$confirm('此平台不兼容ie浏览器，使用ie浏览器可能会出现未知错误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      });
    }

    this.formWidth = 'width: 500px;'

  }
}
</script>

<style scoped>
.catalogForm .form-label {
  width: 190px;
}

.catalogForm .form-label em {
  color: #e64545;
  margin-right: 5px;
}

.catalogForm .form-fields {
  margin-left: 200px;
}

.shipping-cost-tm .tm-status-off {
  background: none;
  padding: 0;
  color: #1470cc
}

</style>
